<template>
  <div class="pagination">
    <!-- 上 -->
    <button class="syy" :disabled="pageNo == 1" @click="getPageNo">
      上一页
    </button>
    <button class="zj active" @click="getPageNo">1</button>
    <button class="zj" @click="getPageNo">2</button>
    <button class="zj" @click="getPageNo">3</button>
    <button class="zj" @click="getPageNo">···</button>
    <button class="syy" @click="getPageNo">下一页</button>
  </div>
</template>

<script>
export default {
  name: "Pagination2",
  props: ["pageNo", "pageSize", "total", "continues"],
  methods: {
    getPageNo(val) {
      this.$bus.$emit("showNopermiss", true);
    },
  },
};
</script>

<style lang="less" scoped>
.pagination {
  text-align: right;

  button {
    margin: 0 5px;
    color: #000;
    outline: none;
    border-radius: 2px;
    padding: 0 5px;
    vertical-align: top;
    display: inline-block;
    font-size: 13px;
    min-width: 35.5px;
    height: 28px;
    line-height: 28px;
    cursor: pointer;
    box-sizing: border-box;
    text-align: center;
    border: 0;
    border-radius: 5px;

    &[disabled] {
      color: #000;
      cursor: not-allowed;
    }

    &.active {
      cursor: not-allowed;
      background-color: #e5e6ee;
      color: #000;
    }
  }
  .syy {
    min-width: 60px;
    height: 28px;
    font-size: 12px;
    background: #e5e6ee;
  }
  .zj {
    min-width: 60px;

    height: 28px;
    background: none;
  }
}

.active {
  background: skyblue;
}
</style>
